import { NgModule } from '@angular/core';
import { SwopsPage } from './swops.page';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { SharedModule } from './../shared-module/shared.module';
import { SwopsPageRoutingModule } from './swops-routing.module';

@NgModule({
  imports: [
    IonicModule,
    FormsModule,
    CommonModule,
    SharedModule,
    SwopsPageRoutingModule
  ],
  declarations: [SwopsPage]
})
export class SwopsPageModule {}
